/* Fotoescuela — interacciones mínimas y accesibles. Sin dependencias. */
(function () {
  'use strict';

  /* ---------------------------------------------------------------
     Textos traducibles. Los pinta Liquid en window.feTextos (ver
     snippets/fe-textos.liquid) porque una cadena escrita aquí dentro no es
     traducible para Shopify: no la ve ninguna app ni el panel de idiomas.
     Si el puente no está, se usa el castellano de siempre y nada se rompe.
     --------------------------------------------------------------- */
  function T(clave, porDefecto) {
    var t = window.feTextos;
    return (t && t[clave]) || porDefecto;
  }

  /* ---------------------------------------------------------------
     Cuántas unidades pide el selector de cantidad de Horizon.

     Importa porque cuando hay extras marcados no enviamos el <form>: montamos
     el carrito a mano, y antes se escribía `quantity: 1` a fuego. Quien ponía
     2 y marcaba un extra se llevaba UN lote y pagaba uno: el 2 se perdía sin
     avisar. Pedir 2 packs iguales es justo cómo se encarga un lote adicional
     —padres separados, los abuelos—, y así el precio sale del curso elegido
     en vez de un producto aparte con precios de etapa fijos, que en FEP Sant
     Jaume, Sant Gervasi y Real Monasterio no cuadraban.

     Los extras NO se multiplican por esto: cada uno lleva su propio contador.
     --------------------------------------------------------------- */
  function cantidadBase(form) {
    var input = form ? form.querySelector('input[name="quantity"]') : null;
    var n = input ? parseInt(input.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  /* El selector de cantidad que Horizon pinta dentro del formulario. Se
     localiza desde el <form> y no desde el documento porque en una página de
     producto puede haber más de uno (productos relacionados, carrito). */
  function selectorCantidad(form) {
    return form ? form.querySelector('.quantity-selector-wrapper') : null;
  }

  /* El selector de cantidad de Horizon sale sin ninguna etiqueta visible, sólo
     con un aria-label. En un lote de colegio eso no se entiende: hay que decir
     que ahí se piden packs IGUALES del mismo alumno/a, que es como se pide un
     lote adicional desde que dejó de ser un producto aparte.

     El texto lo pone Liquid, traducido, y SÓLO en los lotes de colegio
     (`alumno-por-curso`). En los productos sueltos —Archivo Digital, Copia
     Extra, Pack 3 Cristmas, que piden las familias de centros que no venden
     online— no hay atributo y el selector se queda como estaba. */
  function ponEtiquetaCantidad(root, cantidadWrap) {
    if (!root || !cantidadWrap) return;
    var texto = root.getAttribute('data-fe-cantidad-label');
    if (!texto) return;
    var previo = cantidadWrap.previousElementSibling;
    if (previo && previo.hasAttribute('data-fe-cantidad-titulo')) return;  // ya puesta
    var label = document.createElement('p');
    label.className = 'fe-field__label';
    label.setAttribute('data-fe-cantidad-titulo', '');
    label.textContent = texto;
    cantidadWrap.parentNode.insertBefore(label, cantidadWrap);
    var nota = root.getAttribute('data-fe-cantidad-nota');
    if (nota) {
      var hint = document.createElement('p');
      hint.className = 'fe-field__hint';
      hint.textContent = nota;
      cantidadWrap.parentNode.insertBefore(hint, cantidadWrap.nextSibling);
    }
  }


  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------------------------------------------------------------
     Navegación móvil
     --------------------------------------------------------------- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-fe-nav-toggle]');
    var panel = document.getElementById('fe-mobile-nav');
    if (!toggle || !panel) return;

    function setOpen(open) {
      toggle.setAttribute('aria-expanded', String(open));
      panel.setAttribute('data-open', String(open));
      toggle.setAttribute('aria-label', open ? T('cerrar_menu', 'Cerrar menú') : T('abrir_menu', 'Abrir menú'));
    }

    toggle.addEventListener('click', function () {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });

    // Cerrar con Escape y devolver el foco al botón
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        setOpen(false);
        toggle.focus();
      }
    });

    // Cerrar al navegar a un enlace del panel
    panel.addEventListener('click', function (e) {
      if (e.target.closest('a')) setOpen(false);
    });

    // Reiniciar estado al pasar a desktop
    var desktop = window.matchMedia('(min-width: 1040px)');
    desktop.addEventListener('change', function (e) {
      if (e.matches) setOpen(false);
    });
  }

  /* ---------------------------------------------------------------
     Validación de formularios: mensajes en español, aria-invalid,
     foco en el primer campo con error y estado de carga en el submit.
     --------------------------------------------------------------- */
  function messageFor(input) {
    var v = input.validity;
    if (v.valueMissing) return T('obligatorio', 'Este campo es obligatorio.');
    if (v.typeMismatch && input.type === 'email') return T('email', 'Introduce un email válido.');
    if (v.typeMismatch && input.type === 'tel') return T('telefono', 'Introduce un teléfono válido.');
    if (v.patternMismatch) return T('formato', 'El formato no es correcto.');
    if (v.rangeUnderflow) return T('bajo', 'El valor es demasiado bajo.');
    if (v.rangeOverflow) return T('alto', 'El valor es demasiado alto.');
    if (v.tooShort) return T('corto', 'El texto es demasiado corto.');
    return 'Revisa este campo.';
  }

  function setFieldState(input) {
    var field = input.closest('.fe-field');
    if (!field) return true;
    var errorEl = field.querySelector('.fe-field__error-text');
    var valid = input.checkValidity();

    field.setAttribute('data-invalid', String(!valid));
    input.setAttribute('aria-invalid', String(!valid));
    if (errorEl) errorEl.textContent = valid ? '' : messageFor(input);
    return valid;
  }

  function initForms() {
    var forms = document.querySelectorAll('[data-fe-form] form');

    Array.prototype.forEach.call(forms, function (form) {
      var controls = form.querySelectorAll('.fe-input, .fe-select, .fe-textarea');

      Array.prototype.forEach.call(controls, function (input) {
        // Validar al salir del campo; re-validar en vivo solo si ya estaba en error
        input.addEventListener('blur', function () {
          setFieldState(input);
        });
        input.addEventListener('input', function () {
          var field = input.closest('.fe-field');
          if (field && field.getAttribute('data-invalid') === 'true') setFieldState(input);
        });
      });

      form.addEventListener('submit', function (e) {
        var firstInvalid = null;

        Array.prototype.forEach.call(controls, function (input) {
          if (!setFieldState(input) && !firstInvalid) firstInvalid = input;
        });

        if (firstInvalid) {
          e.preventDefault();
          firstInvalid.focus();
          firstInvalid.scrollIntoView({
            behavior: reduceMotion.matches ? 'auto' : 'smooth',
            block: 'center'
          });
          return;
        }

        var submit = form.querySelector('[type="submit"]');
        if (submit) {
          submit.setAttribute('data-loading', 'true');
          submit.setAttribute('aria-busy', 'true');
        }
      });
    });
  }

  /* ---------------------------------------------------------------
     Reveal on scroll (respeta prefers-reduced-motion)
     --------------------------------------------------------------- */
  function initReveal() {
    var items = document.querySelectorAll('.fe-reveal');
    if (!items.length) return;

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, function (el) {
        el.classList.add('is-in');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    Array.prototype.forEach.call(items, function (el) {
      io.observe(el);
    });
  }

  /* ---------------------------------------------------------------
     Enlace de anclaje: mover el foco al destino (accesibilidad)
     --------------------------------------------------------------- */
  function initAnchorFocus() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;
      var id = link.getAttribute('href').slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      window.setTimeout(function () {
        target.focus({ preventScroll: true });
      }, 400);
    });
  }

  /* ---------------------------------------------------------------
     Buscador de colegios: filtra la lista en cliente y anuncia
     el número de resultados a lectores de pantalla.
     --------------------------------------------------------------- */
  function initSchoolSearch() {
    var input = document.querySelector('[data-fe-school-search]');
    var list = document.querySelector('[data-fe-school-list]');
    if (!input || !list) return;

    var items = list.querySelectorAll('.fe-school');
    var counter = document.getElementById(input.getAttribute('aria-describedby'));
    var empty = document.querySelector('[data-fe-school-empty]');

    function normalise(str) {
      // Ignora acentos: "josé" encuentra "jose" y viceversa
      return str
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    }

    input.addEventListener('input', function () {
      var q = normalise(input.value.trim());
      var shown = 0;

      Array.prototype.forEach.call(items, function (item) {
        var match = q === '' || normalise(item.getAttribute('data-name') || '').indexOf(q) !== -1;
        item.hidden = !match;
        if (match) shown++;
      });

      if (counter) {
        counter.textContent =
          shown === 1
          ? T('centros_uno', '1 centro encontrado')
          : shown + ' ' + T('centros_varios', 'centros encontrados');
      }
      if (empty) empty.hidden = shown !== 0;
    });
  }

  /* ---------------------------------------------------------------
     Preselecciona el colegio en la ficha de producto a partir de
     ?colegio= en la URL, que es lo que enlaza el selector de centros.
     --------------------------------------------------------------- */
  function initSchoolPrefill() {
    var field = document.querySelector('[data-fe-lip-school]');
    if (!field) return;

    var value = new URLSearchParams(window.location.search).get('colegio');
    if (!value) return;

    if (field.tagName === 'SELECT') {
      var match = Array.prototype.find.call(field.options, function (opt) {
        return opt.value.toLowerCase() === value.toLowerCase();
      });
      if (match) field.value = match.value;
    } else {
      field.value = value;
    }
  }

  /* ---------------------------------------------------------------
     Datos de alumno/a en la ficha de producto: filas repetibles
     (curso + nombre) por cada hijo/a, con total en vivo y, cuando hay
     2 o más, alta múltiple vía Cart API (cada hijo/a = su propia línea,
     misma variante, cantidad 1 — así el precio se multiplica de verdad).
     --------------------------------------------------------------- */
  var moneyFormatter = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });

  function initLineItemFields() {
    var root = document.querySelector('[data-fe-lip]');
    if (!root) return;

    var form = root.closest('form');
    var rowsWrap = root.querySelector('[data-fe-lip-rows]');
    var template = root.querySelector('[data-fe-lip-row-template]');
    var addBtn = root.querySelector('[data-fe-lip-add]');
    var totalEl = root.querySelector('[data-fe-lip-total]');
    var multiBtn = root.querySelector('[data-fe-lip-multi-submit]');
    var errorEl = root.querySelector('[data-fe-lip-error]');
    var unitPriceCents = parseInt(root.getAttribute('data-unit-price'), 10) || 0;
    var nativeSubmit = form ? form.querySelector('button[type="submit"][name="add"]') : null;
    var cantidadWrap = selectorCantidad(form);
    var rowCounter = 1;

    ponEtiquetaCantidad(root, cantidadWrap);

    function rows() {
      return Array.prototype.slice.call(rowsWrap.querySelectorAll('[data-fe-lip-row]'));
    }

    function refresh() {
      var list = rows();

      // El primer alumno/a nunca se puede quitar: siempre queda al menos uno.
      list.forEach(function (row, i) {
        var removeBtn = row.querySelector('[data-fe-lip-row-remove]');
        if (removeBtn) removeBtn.hidden = i === 0;
      });

      if (list.length > 1) {
        var total = (unitPriceCents * list.length) / 100;
        totalEl.hidden = false;
        totalEl.textContent =
          list.length + ' ' + T('alumnos_x', 'alumnos/as ×') + ' ' + moneyFormatter.format(unitPriceCents / 100) + ' = ' + moneyFormatter.format(total);
        if (multiBtn) multiBtn.hidden = false;
        if (nativeSubmit) nativeSubmit.hidden = true;
        // Con varios hijos/as el selector de cantidad no significa nada: cada
        // uno entra como su propia línea de cantidad 1, así que un 2 ahí
        // arriba no haría lo que la persona espera. Se esconde en vez de
        // ignorarse en silencio.
        if (cantidadWrap) cantidadWrap.hidden = true;
      } else {
        totalEl.hidden = true;
        if (multiBtn) multiBtn.hidden = true;
        if (nativeSubmit) nativeSubmit.hidden = false;
        if (cantidadWrap) cantidadWrap.hidden = false;
      }
    }

    if (addBtn && template) {
      addBtn.addEventListener('click', function () {
        var clone = template.content.cloneNode(true);
        var row = clone.querySelector('[data-fe-lip-row]');
        var select = row.querySelector('[data-fe-lip-curso]');
        var input = row.querySelector('[data-fe-lip-nombre]');
        var label1 = row.querySelectorAll('.fe-field__label')[0];
        var label2 = row.querySelectorAll('.fe-field__label')[1];
        var id1 = 'fe-lip-curso-extra-' + rowCounter;
        var id2 = 'fe-lip-alumno-extra-' + rowCounter;
        rowCounter++;

        select.id = id1;
        if (label1) label1.setAttribute('for', id1);
        input.id = id2;
        if (label2) label2.setAttribute('for', id2);

        var removeBtn = row.querySelector('[data-fe-lip-row-remove]');
        removeBtn.addEventListener('click', function () {
          row.remove();
          refresh();
        });

        rowsWrap.appendChild(row);
        refresh();
        select.focus();
      });
    }

    function collectChildren() {
      return rows().map(function (row) {
        var ref = row.querySelector('[data-fe-lip-ref]');
        return {
          curso: row.querySelector('[data-fe-lip-curso]').value.trim(),
          nombre: row.querySelector('[data-fe-lip-nombre]').value.trim(),
          ref: ref ? ref.value.trim() : '',
        };
      });
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.hidden = false;
      errorEl.textContent = message;
    }

    function hideError() {
      if (errorEl) errorEl.hidden = true;
    }

    if (multiBtn) {
      multiBtn.addEventListener('click', function () {
        hideError();

        var schoolField = root.querySelector('[data-fe-lip-school]');
        var colegio = schoolField ? schoolField.value.trim() : '';
        var children = collectChildren();
        var variantInput = form.querySelector('input[name="id"]');
        var variantId = variantInput ? variantInput.value : null;

        if (!colegio) {
          showError(T('colegio_falta', 'Indica el colegio antes de continuar.'));
          if (schoolField) schoolField.focus();
          return;
        }

        var incomplete = children.some(function (c) {
          return !c.curso || !c.nombre;
        });
        if (incomplete) {
          showError(T('completa', 'Completa el curso y el nombre de cada alumno/a.'));
          return;
        }

        if (!variantId) {
          showError(T('sin_producto', 'No se ha podido identificar el producto. Recarga la página e inténtalo de nuevo.'));
          return;
        }

        multiBtn.setAttribute('data-loading', 'true');
        multiBtn.disabled = true;

        var items = children.map(function (c) {
          var properties = {
            Colegio: colegio,
            Curso: c.curso,
            'Nombre del alumno': c.nombre,
          };
          // Opcional: solo se adjunta si la familia la ha escrito, para no
          // llenar los pedidos de propiedades vacías.
          if (c.ref) properties['Referencia de la foto'] = c.ref;
          return { id: variantId, quantity: 1, properties: properties };
        });

        fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || T('error_carrito', 'Error al añadir al carrito')); });
            return res.json();
          })
          .then(function () {
            window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/') + 'cart';
          })
          .catch(function (err) {
            multiBtn.removeAttribute('data-loading');
            multiBtn.disabled = false;
            showError(err.message || T('pedido_error', 'No se ha podido completar el pedido. Inténtalo de nuevo.'));
          });
      });
    }

    refresh();
  }

  /* ---------------------------------------------------------------
     Lleva el colegio elegido en el selector a través de la colección
     hasta la ficha de producto: si la URL actual tiene ?colegio=, se lo
     añade a cada enlace de producto de la página (tarjetas de colección),
     para que el desplegable de Colegio llegue ya rellenado sin tener
     que tocar los componentes internos del tema.
     --------------------------------------------------------------- */
  function initSchoolContextPropagation() {
    var params = new URLSearchParams(window.location.search);
    var colegio = params.get('colegio');
    if (!colegio) return;

    var links = document.querySelectorAll('a[href^="/products/"]');
    Array.prototype.forEach.call(links, function (link) {
      if (/[?&]colegio=/.test(link.getAttribute('href'))) return;
      var sep = link.getAttribute('href').indexOf('?') === -1 ? '?' : '&';
      link.setAttribute('href', link.getAttribute('href') + sep + 'colegio=' + encodeURIComponent(colegio));
    });
  }

  /* ---------------------------------------------------------------
     Add-ons de "Archivo Digital - {Colegio}" (Copia Extra, Lote Completo,
     Packs de Hermanos — ver snippets/fe-addons.liquid): checkboxes que
     revelan un selector de variante y suman su precio al total. Si al
     enviar el formulario hay algún add-on marcado, se interceptan el
     Archivo Digital y cada add-on como líneas de carrito separadas pero
     enlazadas por una propiedad `_bundle_id` compartida (para que el
     carrito las agrupe visualmente y las trate como un solo bloque). Sin
     add-ons marcados, el <form> nativo se envía tal cual.
     --------------------------------------------------------------- */
  var QTY_MAX_EXTRAS = 20;

  /* Conecta UN panel de extras. Hay uno por hijo/a (ver fe-addons.liquid), así
     que esto no puede vivir dentro de initAddons ni dar por hecho que solo hay
     uno: el repetidor de hermanos clona bloques enteros y conecta el suyo.

     Devuelve un lector de las líneas de carrito que aporta el panel, para que
     quien monte el pedido no tenga que volver a leer el DOM. `alCambiar` se
     avisa en cada cambio, que es como el total de arriba se entera. */
  function conectarPanelExtras(root, alCambiar) {
    var addons = Array.prototype.slice.call(root.querySelectorAll('[data-fe-addon]'));
    var totalEl = root.querySelector('[data-fe-addons-total]');
    var QTY_MAX = QTY_MAX_EXTRAS;

    function checkedAddons() {
      return addons.filter(function (el) {
        var cb = el.querySelector('[data-fe-addon-toggle]');
        return cb && cb.checked;
      });
    }

    function filasDe(el) {
      return Array.prototype.slice.call(el.querySelectorAll('[data-fe-addon-linea]'));
    }

    function cantidadDe(fila) {
      var input = fila.querySelector('[data-fe-qty]');
      var n = parseInt(input && input.value, 10);
      if (!(n > 0)) return 0;
      return Math.min(n, QTY_MAX);
    }

    // Las líneas que este add-on aporta al carrito. Un extra con tamaños
    // devuelve una por tamaño pedido —se pueden querer dos 15x20 y un 13x18 a
    // la vez—; el Archivo Digital, que no tiene variantes, devuelve una sola.
    function lineasDe(el) {
      var filas = filasDe(el);
      if (filas.length) {
        return filas
          .map(function (fila) {
            return {
              id: fila.getAttribute('data-variant'),
              price: parseFloat(fila.getAttribute('data-price')) || 0,
              qty: cantidadDe(fila),
              label:
                (el.getAttribute('data-title') || '') +
                ' — ' +
                (fila.getAttribute('data-label') || ''),
            };
          })
          .filter(function (l) {
            return l.id && l.qty > 0;
          });
      }
      var hidden = el.querySelector('[data-fe-addon-variant]');
      if (!hidden || !hidden.value) return [];
      return [
        {
          id: hidden.value,
          price: parseFloat(hidden.getAttribute('data-price')) || 0,
          qty: 1,
          label: el.getAttribute('data-title') || '',
        },
      ];
    }

    function lineas() {
      var todas = [];
      checkedAddons().forEach(function (el) {
        todas = todas.concat(lineasDe(el));
      });
      return todas;
    }

    function ponerCantidad(fila, n) {
      var input = fila.querySelector('[data-fe-qty]');
      if (!input) return;
      input.value = String(Math.max(0, Math.min(n, QTY_MAX)));
    }

    function refresh() {
      addons.forEach(function (el) {
        var cb = el.querySelector('[data-fe-addon-toggle]');
        var opciones = el.querySelector('[data-fe-addon-opciones]');
        if (opciones) opciones.hidden = !(cb && cb.checked);

        // Los botones − y + se apagan en los extremos para que se vea que el
        // rango tiene tope, en vez de dejar que no pase nada al pulsarlos.
        filasDe(el).forEach(function (fila) {
          var n = cantidadDe(fila);
          var menos = fila.querySelector('[data-fe-qty-paso="-1"]');
          var mas = fila.querySelector('[data-fe-qty-paso="1"]');
          if (menos) menos.disabled = n <= 0;
          if (mas) mas.disabled = n >= QTY_MAX;
        });
      });

      var pedidas = lineas();

      if (alCambiar) alCambiar(pedidas);

      if (!totalEl) return;

      if (pedidas.length === 0) {
        totalEl.hidden = true;
        return;
      }

      // Solo el subtotal de los extras: el precio del lote depende del curso,
      // y con un panel por hijo/a sumar aquí "el total" diría una cifra
      // distinta en cada bloque. El total del pedido va una sola vez, abajo.
      var sum = 0;
      var unidades = 0;
      pedidas.forEach(function (l) {
        sum += l.price * l.qty;
        unidades += l.qty;
      });

      totalEl.hidden = false;
      totalEl.textContent =
        unidades + (unidades === 1 ? ' extra: +' : ' extras: +') + moneyFormatter.format(sum);
    }

    addons.forEach(function (el) {
      var cb = el.querySelector('[data-fe-addon-toggle]');
      var filas = filasDe(el);

      if (cb) {
        cb.addEventListener('change', function () {
          // Marcar la casilla sin pedir nada no compraría nada: al abrirla se
          // deja una unidad del primer tamaño, que es lo que la persona espera
          // haber hecho. Al cerrarla se vacían todas.
          if (cb.checked) {
            var pedidas = filas.some(function (f) {
              return cantidadDe(f) > 0;
            });
            if (filas.length && !pedidas) ponerCantidad(filas[0], 1);
          } else {
            filas.forEach(function (f) {
              ponerCantidad(f, 0);
            });
          }
          refresh();
        });
      }

      filas.forEach(function (fila) {
        var input = fila.querySelector('[data-fe-qty]');

        function tras(n) {
          ponerCantidad(fila, n);
          // La casilla sigue a las cantidades: si se pide algo se marca sola,
          // y si se vacían todas se desmarca. Así nunca queda marcada una
          // casilla que no añade nada.
          if (cb) {
            cb.checked = filas.some(function (f) {
              return cantidadDe(f) > 0;
            });
          }
          refresh();
        }

        Array.prototype.forEach.call(fila.querySelectorAll('[data-fe-qty-paso]'), function (btn) {
          btn.addEventListener('click', function () {
            var paso = parseInt(btn.getAttribute('data-fe-qty-paso'), 10) || 0;
            tras(cantidadDe(fila) + paso);
          });
        });

        if (input) {
          input.addEventListener('input', function () {
            tras(parseInt(input.value, 10) || 0);
          });
        }
      });
    });

    refresh();

    return { lineas: lineas, refresh: refresh };
  }

  // Lo rellena initAddons con el panel del PRIMER hijo/a, que es el que compra
  // el formulario nativo cuando no hay hermanos.
  var obtenerLineasExtras = null;

  function initAddons() {
    var root = document.querySelector('[data-fe-addons]');
    if (!root) return;

    var form = root.closest('form');
    if (!form) return;

    var errorEl = root.querySelector('[data-fe-addons-error]');
    var submitBtn = form.querySelector('button[type="submit"][name="add"]');

    /* Horizon escucha el submit con un listener delegado en `document` y en
       fase de CAPTURA (ver assets/component.js), así que su `handleSubmit`
       corre SIEMPRE antes que el nuestro y no mira si alguien ha llamado a
       `preventDefault`: añade el producto por su cuenta pase lo que pase. Como
       aquí abajo también lo añadimos —junto con los extras y con el
       `_bundle_id` que los enlaza—, el lote acababa DUPLICADO en el carrito.

       No se puede ganar esa carrera desde el formulario, así que se le quita a
       Horizon el enganche mientras haya extras pedidos: sin el atributo
       `on:submit`, su `getElement()` no encuentra a quién avisar y no hace
       nada. En cuanto no hay extras se le devuelve, para que el caso normal
       —comprar el lote a secas— siga abriendo su cajón del carrito. */
    var enganche = root.closest('[on\\:submit]');
    var engancheValor = enganche ? enganche.getAttribute('on:submit') : null;

    var panel = conectarPanelExtras(root, function (pedidas) {
      if (!enganche || !engancheValor) return;
      if (pedidas.length) enganche.removeAttribute('on:submit');
      else enganche.setAttribute('on:submit', engancheValor);
    });

    obtenerLineasExtras = panel.lineas;

    form.addEventListener('submit', function (e) {
      // Una casilla marcada sin ninguna unidad no aporta nada: se trata igual
      // que si no hubiera extras y se deja pasar el submit nativo.
      var extras = panel.lineas();
      if (!extras.length) return;

      e.preventDefault();
      if (errorEl) errorEl.hidden = true;

      var variantInput = form.querySelector('input[name="id"]');
      var baseVariantId = variantInput ? variantInput.value : null;
      if (!baseVariantId) {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = T('sin_producto', 'No se ha podido identificar el producto. Recarga la página e inténtalo de nuevo.');
        }
        return;
      }

      var bundleId = 'fe-' + Date.now() + '-' + Math.floor(Math.random() * 1e6);

      var baseProperties = {};
      Array.prototype.forEach.call(form.querySelectorAll('[name^="properties["]'), function (input) {
        var match = input.name.match(/properties\[(.+)\]/);
        if (match && input.value) baseProperties[match[1]] = input.value;
      });
      baseProperties['_bundle_id'] = bundleId;

      var items = [{ id: baseVariantId, quantity: cantidadBase(form), properties: baseProperties }];

      extras.forEach(function (v) {
        // El extra viaja con los mismos datos del alumno/a que la línea
        // principal. Antes solo llevaba `_bundle_id`, así que en un listado de
        // pedidos aparecía una copia extra sin saber de quién era: había que
        // ir a buscar la línea hermana. El curso no se copia porque en estos
        // productos es la variante, no una propiedad.
        var addonProperties = { _bundle_id: bundleId, 'Vinculado a': v.label };
        ['Colegio', 'Nombre del alumno', 'Referencia de la foto'].forEach(function (key) {
          if (baseProperties[key]) addonProperties[key] = baseProperties[key];
        });
        items.push({ id: v.id, quantity: v.qty, properties: addonProperties });
      });

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('data-loading', 'true');
      }

      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || T('error_carrito', 'Error al añadir al carrito')); });
          return res.json();
        })
        .then(function () {
          window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root
            : '/') + 'cart';
        })
        .catch(function (err) {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.removeAttribute('data-loading');
          }
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.textContent = err.message || T('pedido_error', 'No se ha podido completar el pedido. Inténtalo de nuevo.');
          }
        });
    });
  }

  /* ---------------------------------------------------------------
     Carrito: un add-on nunca puede quedarse huérfano. Quitar un extra suelto
     sí se puede —lo gestiona Horizon con su propio botón—, pero al borrar el
     Archivo Digital "padre" hay que llevarse con él sus extras: eso es lo que
     se intercepta aquí, quitando de una sola pasada, vía Cart API, todas las
     líneas que comparten su `_bundle_id`.
     --------------------------------------------------------------- */
  function initCartBundles() {
    var parents = document.querySelectorAll('[data-fe-bundle-role="parent"]');
    if (!parents.length) return;

    Array.prototype.forEach.call(parents, function (row) {
      var bundleId = row.getAttribute('data-fe-bundle-id');
      var removeBtn = row.querySelector('.cart-items__remove');
      if (!bundleId || !removeBtn) return;

      var children = Array.prototype.filter.call(
        document.querySelectorAll('[data-fe-bundle-role="child"]'),
        function (child) {
          return child.getAttribute('data-fe-bundle-id') === bundleId;
        }
      );
      if (!children.length) return; // sin add-ons: que Horizon lo gestione

      removeBtn.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();

          var updates = {};
          updates[row.getAttribute('data-key')] = 0;
          children.forEach(function (child) {
            updates[child.getAttribute('data-key')] = 0;
          });

          removeBtn.disabled = true;

          fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + 'cart/update.js'
            : '/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates }),
          })
            .then(function (res) {
              if (!res.ok) throw new Error(T('carrito_error', 'No se ha podido actualizar el carrito'));
              return res.json();
            })
            .then(function () {
              window.location.reload();
            })
            .catch(function () {
              removeBtn.disabled = false;
            });
        },
        true // fase de captura: llega antes que el manejador de Horizon
      );
    });
  }

  /* ---------------------------------------------------------------
     Carrito: oferta del Archivo Digital a precio especial (ver
     snippets/cart-products.liquid). Añade el archivo con los mismos datos
     del alumno que su lote y con su `_bundle_id`, para que cuelgue de él y
     se borre con él. Si el lote no trae `_bundle_id` (pedido sin JS o de
     antes de los bloques), primero se le pone uno con /cart/change.js:
     sin eso la oferta volvería a salir con el archivo ya en el carrito.

     Va por delegación en `document` porque Horizon vuelve a pintar el
     cajón del carrito cada vez que cambia algo, y un manejador puesto en
     el botón se perdería en el primer repintado.
     --------------------------------------------------------------- */
  function initOfertaDigital() {
    var raiz = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    function post(ruta, datos) {
      return fetch(raiz + ruta, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(datos),
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || d.message); });
        return r.json();
      });
    }

    document.addEventListener('click', function (e) {
      var boton = e.target.closest ? e.target.closest('[data-fe-oferta-digital-boton]') : null;
      if (!boton) return;
      var caja = boton.closest('[data-fe-oferta-digital]');
      if (!caja) return;
      e.preventDefault();

      var error = caja.querySelector('[data-fe-oferta-digital-error]');
      // `item.properties | json` en Liquid sale como lista de pares
      // [[clave, valor], …], no como objeto: se pasa a objeto aquí.
      var propsLote = {};
      try {
        var crudas = JSON.parse(caja.getAttribute('data-propiedades') || '{}') || {};
        if (Array.isArray(crudas)) {
          crudas.forEach(function (par) {
            if (Array.isArray(par) && par.length === 2) propsLote[par[0]] = par[1];
          });
        } else {
          propsLote = crudas;
        }
      } catch (err) {
        propsLote = {};
      }
      var bundleId = caja.getAttribute('data-bundle');
      var nuevoBundle = !bundleId;
      if (nuevoBundle) bundleId = 'fe-' + Date.now() + '-0-' + Math.floor(Math.random() * 1e6);

      // El archivo lleva los datos visibles del lote (colegio, nombre,
      // referencia…), no los ocultos: solo comparte con él el `_bundle_id`.
      var propsArchivo = { _bundle_id: bundleId };
      Object.keys(propsLote).forEach(function (k) {
        if (k.charAt(0) !== '_' && propsLote[k]) propsArchivo[k] = propsLote[k];
      });

      var textoOriginal = boton.textContent;
      boton.disabled = true;
      boton.textContent = T('anadiendo', 'Añadiendo…');
      if (error) error.hidden = true;

      var paso = Promise.resolve();
      if (nuevoBundle) {
        var propsNuevas = {};
        Object.keys(propsLote).forEach(function (k) { propsNuevas[k] = propsLote[k]; });
        propsNuevas._bundle_id = bundleId;
        paso = post('cart/change.js', {
          id: caja.getAttribute('data-key'),
          quantity: Number(caja.getAttribute('data-cantidad')) || 1,
          properties: propsNuevas,
        });
      }

      paso
        .then(function () {
          return post('cart/add.js', {
            items: [{ id: Number(caja.getAttribute('data-variante')), quantity: 1, properties: propsArchivo }],
          });
        })
        .then(function () {
          // En la página del carrito basta con recargar; desde el cajón se va
          // al carrito, que es donde se ve el archivo colgado de su lote.
          if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
          else window.location.href = raiz + 'cart';
        })
        .catch(function (err) {
          boton.disabled = false;
          boton.textContent = textoOriginal;
          if (error) {
            error.textContent = (err && err.message) || T('pedido_no_anadido', 'No se ha podido añadir el pedido. Inténtalo de nuevo.');
            error.hidden = false;
          }
        });
    });
  }

  /* ---------------------------------------------------------------
     Curso dentro del cuadro "Datos para personalizar el pedido"
     (productos `alumno-por-curso`).

     El Curso es una variante de Shopify: su desplegable nativo está fuera del
     cuadro y siempre llega con el primer curso elegido, así que quien no lo
     tocaba se llevaba el curso equivocado. Aquí se rellena la copia que hay
     dentro del cuadro con las mismas opciones —ya agrupadas por etapa en
     fe-curso-select.liquid, se clonan en vez de repetir esa lógica—, se
     esconde el nativo y se le trasladan los cambios.

     El selector nativo NO se mueve de sitio: vive dentro de <variant-picker>,
     que escucha los `change` de sus propios hijos. Sacarlo de ahí lo rompería.
     Y como al cambiar de variante Horizon vuelve a pintar ese selector, se
     busca de nuevo en cada cambio en lugar de guardarse una referencia.
     --------------------------------------------------------------- */

  /* ---------------------------------------------------------------
     Contenido del lote (ver snippets/fe-lote-contenido.liquid).

     Se elige por PRECIO, no por etapa: hay centros donde el tramo de 22 €
     acaba a mitad de Primaria, así que el curso no es señal fiable.
     Un precio sin lista no muestra nada, a propósito.
     --------------------------------------------------------------- */
  function mostrarContenidoLote(valorCurso) {
    var caja = document.querySelector('[data-fe-lote]');
    if (!caja) return;
    var listas = caja.querySelectorAll('[data-fe-lote-precio]');
    var titulo = caja.querySelector('[data-fe-lote-title]');
    var precio = null;

    if (valorCurso) {
      var pares = (caja.getAttribute('data-fe-lote-precios') || '').split('|');
      for (var i = 0; i < pares.length; i++) {
        var corte = pares[i].lastIndexOf('=');
        if (corte > 0 && pares[i].slice(0, corte) === valorCurso) {
          precio = pares[i].slice(corte + 1).replace(/[.,]/g, '');
          break;
        }
      }
    }

    var alguna = false;
    Array.prototype.forEach.call(listas, function (ul) {
      var coincide = precio !== null && ul.getAttribute('data-fe-lote-precio') === precio;
      ul.hidden = !coincide;
      if (coincide) alguna = true;
    });
    if (titulo) titulo.hidden = !alguna;

    /* La frase de la fecha límite va con el MISMO precio.

       Cuando en un centro conviven los dos sistemas, esa fecha significa dos
       cosas distintas: pagar un lote que ya está en casa, o pedir uno que se
       entregará en el colegio. Con una frase fija la mitad del colegio leía
       algo falso. Solo entra aquí si el producto declara qué precios son «ya
       está en casa» (ver fe-line-item-fields-curso.liquid); si no, la franja
       lleva una sola frase y no se toca. */
    var plazo = document.querySelector('[data-fe-plazo]');
    if (!plazo) return;

    /* Si la ficha declara las etapas con lote en casa, la frase va por el
       curso y no por el precio (Jesús-Maria Badalona: 17 € es lote en casa en
       3º-6º de Primaria y pedido online en la ESO). */
    var modos = plazo.getAttribute('data-fe-plazo-modos');
    if (modos) {
      var modo = null;
      if (valorCurso) {
        var ps = modos.split('|');
        for (var j = 0; j < ps.length; j++) {
          var c = ps[j].lastIndexOf('=');
          if (c > 0 && ps[j].slice(0, c) === valorCurso) { modo = ps[j].slice(c + 1); break; }
        }
      }
      Array.prototype.forEach.call(plazo.querySelectorAll('[data-fe-plazo-modo]'), function (sp) {
        sp.hidden = modo === null || sp.getAttribute('data-fe-plazo-modo') !== modo;
      });
      return;
    }

    var frases = plazo.querySelectorAll('[data-fe-plazo-precio]');
    Array.prototype.forEach.call(frases, function (sp) {
      sp.hidden = precio === null || sp.getAttribute('data-fe-plazo-precio') !== precio;
    });
  }

  function initCursoEnCaja() {
    var field = document.querySelector('[data-fe-curso-field]');
    if (!field) return;

    var proxy = field.querySelector('[data-fe-curso-proxy]');
    var errorEl = field.querySelector('[data-fe-curso-error]');
    var form = field.closest('form');
    if (!proxy || !form) return;

    function nativo() {
      // OJO: no buscar por el nombre de la opción. Se traduce —en catalán es
      // «Curs»— y el selector pasa a llamarse options[Curs]; buscando
      // options[Curso] no se encontraba nada, la función se salía, y la ficha
      // en catalán mostraba DOS desplegables: el nativo sin esconder, con el
      // primer curso ya elegido, y el del cuadro vacío.
      var picker = document.querySelector('variant-picker');
      if (!picker) return null;
      return picker.querySelector('select[name="options[Curso]"]')
          || picker.querySelector('select[name^="options["]');
    }

    var origen = nativo();
    if (!origen) return;

    proxy.insertAdjacentHTML('beforeend', origen.innerHTML);
    Array.prototype.forEach.call(proxy.querySelectorAll('option'), function (opt) {
      opt.removeAttribute('selected');
    });

    // El precio de cada curso no viene en el selector nativo de Horizon: sin
    // él el total de varios hijos/as salía a 0,00 €. Lo pinta la ficha en
    // data-fe-precios (euros por id de variante) y se cuelga de cada opción,
    // que es de donde lo leen las filas de hermanos al clonarlas.
    var lip = field.closest('[data-fe-hermanos]');
    var precios = {};
    try {
      precios = JSON.parse((lip && lip.getAttribute('data-fe-precios')) || '{}');
    } catch (e) {}
    Array.prototype.forEach.call(proxy.querySelectorAll('option[data-variant-id]'), function (opt) {
      var precio = precios[opt.getAttribute('data-variant-id')];
      if (precio != null && !opt.hasAttribute('data-price')) opt.setAttribute('data-price', precio);
    });

    // Si se llega con un curso ya elegido en la URL (?variant=), la elección
    // ya está hecha y se respeta. Si no, no hay nada preseleccionado.
    proxy.value = /[?&]variant=/.test(window.location.search) ? origen.value : '';

    field.hidden = false;
    mostrarContenidoLote(proxy.value);
    // La clase va en <html> y no un `hidden` en el propio selector: Horizon
    // repinta el <variant-picker> en cada cambio y se llevaría el atributo.
    document.documentElement.classList.add('fe-curso-en-caja');

    // El aviso de precio nace dentro del cuadro y se muda al lado del precio,
    // que es donde engaña. Si no se encuentra el bloque de precio se queda
    // donde está: mejor en el sitio equivocado que no salir.
    var nota = field.querySelector('[data-fe-precio-nota]');
    if (nota) {
      var precioEl = document.querySelector('product-price');
      if (precioEl) precioEl.appendChild(nota);
      nota.hidden = proxy.value !== '';
    }

    proxy.addEventListener('change', function () {
      if (errorEl) errorEl.hidden = true;
      if (nota) nota.hidden = true;
      var actual = nativo();
      if (!actual || !proxy.value) return;
      actual.value = proxy.value;
      actual.dispatchEvent(new Event('change', { bubbles: true }));
      mostrarContenidoLote(proxy.value);
    });

    // En captura, para cortar antes que los envíos de fe-addons y del
    // repetidor de alumnos: sin curso no se añade nada al carrito.
    form.addEventListener(
      'submit',
      function (e) {
        if (proxy.value) return;
        e.preventDefault();
        e.stopPropagation();
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = T('curso_falta', 'Selecciona el curso de tu hijo/a para continuar.');
        }
        proxy.focus();
      },
      true
    );
  }

  /* ---------------------------------------------------------------
     Hermanos en la ficha de un colegio. A diferencia del repetidor de
     fe-line-item-fields.liquid, aquí el curso es una VARIANTE: cada fila
     aporta su propio `id` de variante y su propio precio (infantil y ESO no
     cuestan igual), así que el total no se calcula multiplicando.

     Con una sola fila no se toca nada y compra el formulario nativo. Con dos
     o más se esconde el botón de Horizon y se usa el nuestro, que arma una
     línea por hijo/a contra la Cart API — que es la única forma de colgar un
     nombre distinto de cada unidad, porque las line item properties son por
     línea, no por unidad.
     --------------------------------------------------------------- */
  function initHermanos() {
    var root = document.querySelector('[data-fe-hermanos]');
    if (!root) return;

    var form = root.closest('form');
    var proxy = root.querySelector('[data-fe-curso-proxy]');
    var rowsWrap = root.querySelector('[data-fe-hermanos-rows]');
    var template = root.querySelector('[data-fe-hermanos-template]');
    var addBtn = root.querySelector('[data-fe-hermanos-add]');
    var totalEl = root.querySelector('[data-fe-hermanos-total]');
    var submitBtn = root.querySelector('[data-fe-hermanos-submit]');
    var errorEl = root.querySelector('[data-fe-hermanos-error]');
    // La oferta de la foto de hermanos solo existe en los centros que la tienen
    // (la pinta fe-line-item-fields-curso.liquid según la etiqueta del producto);
    // en el resto es null y todo lo de abajo se salta solo.
    var ofertaEl = root.querySelector('[data-fe-hermanos-oferta]');
    var ofertaCheck = ofertaEl ? ofertaEl.querySelector('[data-fe-hermanos-oferta-check]') : null;
    // La referencia de la tarjeta de germans: es lo unico que identifica esa
    // foto, asi que es obligatoria si se pide y viaja con su linea del pedido.
    // Escribirla ya es decir que la quieren: marca la casilla sola.
    var ofertaRef = ofertaEl ? ofertaEl.querySelector('[data-fe-hermanos-oferta-ref]') : null;
    if (ofertaCheck && ofertaRef) {
      ofertaRef.addEventListener('input', function () {
        if (ofertaRef.value.trim()) ofertaCheck.checked = true;
      });
    }
    var preguntaEl = root.querySelector('[data-fe-hermanos-pregunta]');
    // «Añadir foto de hermanos»: una fila que nace ya como foto de hermanos,
    // con la referencia obligatoria. Se repite tantas veces como tarjetas haya
    // (hermanos, primos…). Va sobre todo por el profesorado, que con su código
    // lo tiene todo de obsequio y pide de una vez las individuales de sus hijos
    // y todas sus fotos de hermanos, cada una con su referencia (José,
    // 21-10-2026). Sin referencia no hay quien encuentre luego esa foto.
    var fotoAddBtn = root.querySelector('[data-fe-hermanos-foto-add]');
    if (!form || !proxy || !rowsWrap || !template || !addBtn) return;

    // Sin opciones clonadas (initCursoEnCaja no encontró el selector nativo)
    // no hay forma de elegir curso en una fila nueva: mejor no ofrecerlo.
    if (!proxy.querySelector('option[data-variant-id]')) return;

    var nombre1 = form.querySelector('[name="properties[Nombre del alumno]"]');
    var ref1 = form.querySelector('[name="properties[Referencia de la foto]"]');
    var colegio = root.getAttribute('data-colegio') || '';
    var nativeSubmit = form.querySelector('button[type="submit"][name="add"]');
    var cantidadWrap = selectorCantidad(form);
    var tituloPanel1 = root.querySelector('[data-fe-addons] .fe-addons__title');
    var contador = 1;

    // Éste es el flujo de los lotes de colegio: aquí sí se explica el selector.
    ponEtiquetaCantidad(root, cantidadWrap);

    // Cada bloque clonado trae su propio panel de extras; aquí se guarda su
    // lector para saber qué ha pedido ESE hijo/a y no otro.
    var panelesPorFila = [];

    // El botón vive dentro de un bloque con su frase de aviso, y es ese bloque
    // el que nace oculto: sin JS no se pueden añadir hermanos y la frase
    // sobraría. Se muestra el contenedor si existe.
    var cta = root.querySelector('[data-fe-hermanos-cta]');
    if (cta) cta.hidden = false;
    addBtn.hidden = false;

    function filas() {
      return Array.prototype.slice.call(rowsWrap.querySelectorAll('[data-fe-hermanos-row]'));
    }

    function panelDe(fila) {
      for (var i = 0; i < panelesPorFila.length; i++) {
        if (panelesPorFila[i].fila === fila) return panelesPorFila[i].panel;
      }
      return null;
    }

    function precioDe(select) {
      var opt = select.options[select.selectedIndex];
      return opt ? parseFloat(opt.getAttribute('data-price')) || 0 : 0;
    }

    function variantDe(select) {
      var opt = select.options[select.selectedIndex];
      return opt ? opt.getAttribute('data-variant-id') : null;
    }

    // «Solo quiero la foto de hermanos»: la familia la elige como curso. Esa
    // foto no se localiza por nombre sino por la referencia de su tarjeta, así
    // que en ese caso la referencia es obligatoria y el nombre no (José,
    // 12-10-2026). Las dos versiones de cada etiqueta vienen pintadas desde
    // Liquid (data-fe-modo) y aquí se enseña la que toca.
    var varHermanos = root.getAttribute('data-hermanos-variante');
    function esHermanos(select) {
      return !!varHermanos && !!select && variantDe(select) === varHermanos;
    }
    function ponModo(campo, hermanos) {
      if (!campo) return;
      Array.prototype.forEach.call(campo.querySelectorAll('[data-fe-modo]'), function (el) {
        el.hidden = (el.getAttribute('data-fe-modo') === 'hermanos') !== hermanos;
      });
    }
    function aplicaModo(select, nombre, ref) {
      var on = esHermanos(select);
      ponModo(nombre && nombre.closest('[data-fe-campo-nombre]'), on);
      ponModo(ref && ref.closest('[data-fe-campo-ref]'), on);
      if (ref) ref.setAttribute('aria-required', on ? 'true' : 'false');
      return on;
    }

    function refresh() {
      var extra = filas();
      var total = 1 + extra.length;

      // Primer hijo/a: aquí sí manda el formulario nativo con un solo alumno,
      // así que el `required` del navegador es el que frena el envío.
      var soloHermanos1 = aplicaModo(proxy, nombre1, ref1);
      if (nombre1) nombre1.required = !soloHermanos1;
      if (ref1) ref1.required = soloHermanos1;
      extra.forEach(function (fila) {
        aplicaModo(
          fila.querySelector('[data-fe-hermanos-curso]'),
          fila.querySelector('[data-fe-hermanos-nombre]'),
          fila.querySelector('[data-fe-hermanos-ref]')
        );
      });

      // Una foto de hermanos no es un alumno/a: no cuenta para la oferta (que
      // pide dos LOTES) ni para el «N alumnos/as» del total.
      var nFotos = soloHermanos1 ? 1 : 0;
      extra.forEach(function (fila) {
        if (esHermanos(fila.querySelector('[data-fe-hermanos-curso]'))) nFotos++;
      });
      var nAlumnos = total - nFotos;

      // Con hermanos, cada panel de extras deja de ser "el" panel del pedido y
      // pasa a ser el de ese hijo/a: el título lo tiene que decir, o nadie
      // sabe a quién se le está añadiendo la copia.
      if (tituloPanel1) {
        tituloPanel1.textContent = total > 1
        ? T('addons_titulo_hijo', '¿Algo más para este hijo/a?')
        : T('addons_titulo', '¿Quieres añadir algo más?');
      }
      var nHijo = soloHermanos1 ? 0 : 1;
      extra.forEach(function (fila) {
        var titulo = fila.querySelector('[data-fe-hermano-titulo]');
        var nombre = fila.querySelector('[data-fe-hermanos-nombre]');
        var escrito = nombre && nombre.value.trim();
        if (esHermanos(fila.querySelector('[data-fe-hermanos-curso]'))) {
          if (titulo) titulo.textContent = T('hermanos_foto_titulo', 'Foto de hermanos');
          return;
        }
        nHijo++;
        if (titulo) titulo.textContent = escrito || T('hijo_n', 'Hijo/a') + ' ' + nHijo;
      });

      // Con un solo hijo/a no hay oferta que hacer. Al bajar de dos se oculta Y
      // se desmarca: si no, quedaría marcada en silencio y la foto entraría en
      // un pedido que ya no cumple la condición, así que no saldría gratis.
      // (Antes esto vivía dentro del «total > 1» de abajo y al volver a un solo
      // hijo/a la oferta se quedaba a la vista.) Si la familia ya añade sus
      // fotos de hermanos a mano, también sobra: pediría la misma foto dos
      // veces. El descuento automático la sigue regalando en el carrito.
      if (ofertaEl) {
        var hayVarios = nAlumnos > 1 && nFotos === 0;
        ofertaEl.hidden = !hayVarios;
        if (!hayVarios && ofertaCheck) ofertaCheck.checked = false;
      }

      if (total > 1) {
        var suma = precioDe(proxy);
        if (obtenerLineasExtras) {
          obtenerLineasExtras().forEach(function (l) {
            suma += l.price * l.qty;
          });
        }
        extra.forEach(function (fila) {
          suma += precioDe(fila.querySelector('[data-fe-hermanos-curso]'));
          var panel = panelDe(fila);
          if (panel) {
            panel.lineas().forEach(function (l) {
              suma += l.price * l.qty;
            });
          }
        });
        totalEl.hidden = false;
        var resumen = [];
        if (nAlumnos) resumen.push(nAlumnos + ' ' + T('alumnos_punto', 'alumnos/as ·'));
        if (nFotos) resumen.push(nFotos + ' ' + T('foto_hermanos_x', '× foto de hermanos ·'));
        resumen.push(moneyFormatter.format(suma));
        totalEl.textContent = resumen.join(' ');

        // La pregunta «¿tienes más de un hijo o hija?» sobra en cuanto ya
        // hay uno añadido: está contestada. El botón se queda, que es lo
        // que hace falta para el tercero y el cuarto.
        if (preguntaEl) preguntaEl.hidden = total > 1;
        submitBtn.hidden = false;
        if (nativeSubmit) nativeSubmit.hidden = true;
        // Con varios hermanos el selector de cantidad no significa nada: cada
        // hijo/a entra como su propia línea de cantidad 1. Se esconde en vez
        // de quedarse ahí ignorándose en silencio.
        if (cantidadWrap) cantidadWrap.hidden = true;
      } else {
        totalEl.hidden = true;
        submitBtn.hidden = true;
        if (nativeSubmit) nativeSubmit.hidden = false;
        if (cantidadWrap) cantidadWrap.hidden = false;
      }
    }

    function nuevaFila(comoHermanos) {
      var clone = template.content.cloneNode(true);
      var fila = clone.querySelector('[data-fe-hermanos-row]');
      var select = fila.querySelector('[data-fe-hermanos-curso]');
      var nombre = fila.querySelector('[data-fe-hermanos-nombre]');
      var ref = fila.querySelector('[data-fe-hermanos-ref]');
      var labels = fila.querySelectorAll('.fe-field__label');

      // Mismos cursos que arriba, incluida la opción vacía de cabecera: una
      // fila nueva nace sin curso elegido, igual que la primera.
      select.insertAdjacentHTML('beforeend', proxy.innerHTML);
      select.value = '';

      contador++;
      var idCurso = 'fe-hermano-curso-' + contador;
      var idNombre = 'fe-hermano-nombre-' + contador;
      var idRef = 'fe-hermano-ref-' + contador;
      select.id = idCurso;
      nombre.id = idNombre;
      ref.id = idRef;
      if (labels[0]) labels[0].setAttribute('for', idCurso);
      if (labels[1]) labels[1].setAttribute('for', idNombre);
      if (labels[2]) labels[2].setAttribute('for', idRef);

      select.addEventListener('change', refresh);
      nombre.addEventListener('input', refresh);
      fila.querySelector('[data-fe-hermanos-row-remove]').addEventListener('click', function () {
        panelesPorFila = panelesPorFila.filter(function (p) {
          return p.fila !== fila;
        });
        fila.remove();
        refresh();
      });

      rowsWrap.appendChild(fila);

      // El panel se conecta DESPUÉS de meter el bloque en el documento: antes
      // vive en el fragmento del <template> y sus listeners se perderían.
      var panelFila = fila.querySelector('[data-fe-addons]');
      if (panelFila) {
        panelesPorFila.push({ fila: fila, panel: conectarPanelExtras(panelFila, refresh) });
      }

      // La foto de hermanos es la variante HERMANOS/GERMANS del desplegable.
      // Se busca por su id y no por el texto, que cambia con el idioma.
      if (comoHermanos) {
        Array.prototype.some.call(select.options, function (opt) {
          if (opt.getAttribute('data-variant-id') !== varHermanos) return false;
          select.value = opt.value;
          return true;
        });
      }

      refresh();
      (comoHermanos ? ref : select).focus();
    }

    addBtn.addEventListener('click', function () {
      nuevaFila(false);
    });
    if (fotoAddBtn) {
      fotoAddBtn.hidden = !varHermanos;
      fotoAddBtn.addEventListener('click', function () {
        nuevaFila(true);
      });
    }

    proxy.addEventListener('change', refresh);
    if (nombre1) nombre1.addEventListener('input', refresh);

    // El panel del primer hijo/a lo conecta initAddons, que no sabe de este
    // total: se escucha el contenedor para recalcular cuando se toque.
    var panelPrincipal = root.querySelector('[data-fe-addons]');
    if (panelPrincipal) {
      ['change', 'input', 'click'].forEach(function (evento) {
        panelPrincipal.addEventListener(evento, refresh);
      });
    }

    function fallo(mensaje, foco) {
      errorEl.hidden = false;
      errorEl.textContent = mensaje;
      if (foco) foco.focus();
    }

    submitBtn.addEventListener('click', function () {
      errorEl.hidden = true;

      var refHermanosFalta = T('hermanos_solo_ref_falta', 'Escribe la referencia de la tarjeta de hermanos: sin ella no sabemos qué foto es.');
      if (!proxy.value) return fallo(T('curso1_falta', 'Selecciona el curso del primer alumno/a.'), proxy);
      if (esHermanos(proxy)) {
        if (ref1 && !ref1.value.trim()) return fallo(refHermanosFalta, ref1);
      } else if (nombre1 && !nombre1.value.trim()) {
        return fallo(T('nombre1_falta', 'Escribe el nombre del primer alumno/a.'), nombre1);
      }

      var alumnos = [
        {
          id: variantDe(proxy),
          nombre: nombre1 ? nombre1.value.trim() : '',
          ref: ref1 ? ref1.value.trim() : '',
          extras: obtenerLineasExtras ? obtenerLineasExtras() : [],
        },
      ];

      var invalido = null;
      filas().forEach(function (fila) {
        var select = fila.querySelector('[data-fe-hermanos-curso]');
        var nombre = fila.querySelector('[data-fe-hermanos-nombre]');
        var ref = fila.querySelector('[data-fe-hermanos-ref]');
        if (!select.value) {
          if (!invalido) invalido = { msg: T('curso_falta_alguno', 'Falta el curso de uno de los alumnos/as.'), el: select };
          return;
        }
        if (esHermanos(select)) {
          if (!ref.value.trim()) {
            if (!invalido) invalido = { msg: refHermanosFalta, el: ref };
            return;
          }
        } else if (!nombre.value.trim()) {
          if (!invalido) invalido = { msg: T('nombre_falta_alguno', 'Falta el nombre de uno de los alumnos/as.'), el: nombre };
          return;
        }
        var panel = panelDe(fila);
        alumnos.push({
          id: variantDe(select),
          nombre: nombre.value.trim(),
          ref: ref.value.trim(),
          extras: panel ? panel.lineas() : [],
        });
      });

      if (invalido) return fallo(invalido.msg, invalido.el);
      if (ofertaCheck && ofertaCheck.checked && ofertaRef && !ofertaRef.value.trim()) {
        return fallo(T('hermanos_ref_falta', 'Escribe la referencia de la tarjeta de hermanos, o desmarca la foto de hermanos.'), ofertaRef);
      }

      var items = [];
      alumnos.forEach(function (alumno, i) {
        if (!alumno.id) return;
        // Un `_bundle_id` propio por hijo/a: si compartieran uno, borrar el
        // lote de un hermano se llevaría por delante el del otro (ver
        // initCartBundles).
        var bundleId = 'fe-' + Date.now() + '-' + i + '-' + Math.floor(Math.random() * 1e6);
        // En la foto de hermanos sola el nombre puede venir vacío: entonces no
        // se manda, para no dejar una propiedad en blanco en el pedido.
        var props = { Colegio: colegio, _bundle_id: bundleId };
        if (alumno.nombre) props['Nombre del alumno'] = alumno.nombre;
        if (alumno.ref) props['Referencia de la foto'] = alumno.ref;
        items.push({ id: alumno.id, quantity: 1, properties: props });

        // Cada hijo/a arrastra los extras de SU bloque, con su nombre puesto.
        // Antes se le colgaban todos al primero, y una copia extra del pequeño
        // llegaba a producción a nombre del mayor.
        alumno.extras.forEach(function (l) {
          var extraProps = { _bundle_id: bundleId, 'Vinculado a': l.label, Colegio: colegio };
          if (alumno.nombre) extraProps['Nombre del alumno'] = alumno.nombre;
          if (alumno.ref) extraProps['Referencia de la foto'] = alumno.ref;
          items.push({ id: l.id, quantity: l.qty, properties: extraProps });
        });
      });

      // La foto de hermanos va como línea propia y SIN `_bundle_id`: no pertenece a
      // ningún hijo/a en concreto, así que borrar el lote de uno no debe llevársela
      // por delante. El precio lo ajusta el descuento automático de Shopify.
      if (ofertaCheck && ofertaCheck.checked && ofertaEl.getAttribute('data-variante')) {
        // Lo que identifica la foto de hermanos es la referencia de SU tarjeta,
        // no los nombres: repetir «Ana + Pau» de las lineas de arriba no servia
        // para localizarla (José, 06-10-2026). Mismo nombre de propiedad que las
        // demas lineas, para que en el pedido se lea igual.
        var propsHermanos = { Colegio: colegio };
        if (ofertaRef && ofertaRef.value.trim()) propsHermanos['Referencia de la foto'] = ofertaRef.value.trim();
        items.push({
          id: Number(ofertaEl.getAttribute('data-variante')),
          quantity: 1,
          properties: propsHermanos,
        });
      }

      if (!items.length) return fallo(T('pedido_no_preparado', 'No se ha podido preparar el pedido. Recarga la página.'));

      submitBtn.disabled = true;
      var textoOriginal = submitBtn.textContent;
      submitBtn.textContent = submitBtn.getAttribute('data-loading-label') || T('anadiendo', 'Añadiendo…');

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || d.message); });
          window.location.href = '/cart';
        })
        .catch(function (err) {
          submitBtn.disabled = false;
          submitBtn.textContent = textoOriginal;
          fallo(err.message || T('pedido_no_anadido', 'No se ha podido añadir el pedido. Inténtalo de nuevo.'));
        });
    });

    refresh();
  }

  /* ---------------------------------------------------------------
     La muestra de la tarjeta, en un flotante
     El campo de la referencia es OPCIONAL y la familia esta rellenando datos:
     llevarla a la seccion de abajo le haria perder el sitio. Se abre encima y
     al cerrar sigue donde estaba.
     --------------------------------------------------------------- */
  function initModalTarjeta() {
    var modal = document.querySelector('[data-fe-modal-tarjeta]');
    if (!modal) return;

    function abre() {
      // showModal() da Esc, foco atrapado y fondo inerte. Si el navegador no
      // lo trae, se abre como bloque normal y al menos se ve.
      if (typeof modal.showModal === 'function') modal.showModal();
      else modal.setAttribute('open', '');
    }
    function cierra() {
      if (typeof modal.close === 'function') modal.close();
      else modal.removeAttribute('open');
    }

    Array.prototype.forEach.call(document.querySelectorAll('[data-fe-ver-tarjeta]'), function (b) {
      b.addEventListener('click', abre);
    });
    Array.prototype.forEach.call(modal.querySelectorAll('[data-fe-modal-cerrar]'), function (b) {
      b.addEventListener('click', cierra);
    });
    // Tocar fuera de la caja tambien cierra: ese clic cae en el <dialog>, no
    // en el contenido, que vive dentro de .fe-modal__caja.
    modal.addEventListener('click', function (e) { if (e.target === modal) cierra(); });
  }

  /* ---------------------------------------------------------------
     Carrusel de testimonios (sections/fe-testimonials.liquid, modo
     «carrusel»). La pista ya se desplaza sola con scroll-snap; aquí solo se
     añaden las flechas, el contador «1 / 3» y el «Leer más» de las citas
     largas. Los textos llegan traducidos en data-* desde Liquid.
     --------------------------------------------------------------- */
  function initCarrusel() {
    var carruseles = document.querySelectorAll('[data-fe-carrusel]');
    Array.prototype.forEach.call(carruseles, function (root) {
      var pista = root.querySelector('[data-fe-carrusel-pista]');
      var nav = root.querySelector('[data-fe-carrusel-nav]');
      var prev = root.querySelector('[data-fe-carrusel-prev]');
      var next = root.querySelector('[data-fe-carrusel-next]');
      var cuenta = root.querySelector('[data-fe-carrusel-cuenta]');
      if (!pista) return;
      var piezas = pista.querySelectorAll('.fe-carrusel__pieza');

      // «Leer más»: solo en las citas que de verdad pasan de siete líneas.
      Array.prototype.forEach.call(pista.querySelectorAll('[data-fe-cita]'), function (cita) {
        cita.classList.add('is-larga');
        if (cita.scrollHeight <= cita.clientHeight + 2) {
          cita.classList.remove('is-larga');
          return;
        }
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'fe-quote__mas';
        btn.textContent = root.getAttribute('data-leer-mas') || 'Leer más';
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', function () {
          var abierta = cita.classList.toggle('is-abierta');
          btn.textContent = abierta
            ? root.getAttribute('data-leer-menos') || 'Leer menos'
            : root.getAttribute('data-leer-mas') || 'Leer más';
          btn.setAttribute('aria-expanded', abierta ? 'true' : 'false');
        });
        cita.insertAdjacentElement('afterend', btn);
      });

      if (!nav || piezas.length < 2) return;

      function paso() {
        var a = piezas[0].getBoundingClientRect();
        var b = piezas[1].getBoundingClientRect();
        return Math.abs(b.left - a.left) || pista.clientWidth;
      }
      function actual() {
        return Math.round(pista.scrollLeft / paso());
      }
      function pinta() {
        var max = pista.scrollWidth - pista.clientWidth;
        var visibles = Math.max(1, Math.round(pista.clientWidth / paso()));
        // Si caben todas, sobran las flechas.
        nav.hidden = max <= 2;
        prev.disabled = pista.scrollLeft <= 2;
        next.disabled = pista.scrollLeft >= max - 2;
        var desde = Math.min(actual() + 1, piezas.length);
        var hasta = Math.min(desde + visibles - 1, piezas.length);
        cuenta.textContent = (desde === hasta ? desde : desde + '–' + hasta) + ' / ' + piezas.length;
      }
      prev.addEventListener('click', function () {
        pista.scrollBy({ left: -paso(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        pista.scrollBy({ left: paso(), behavior: 'smooth' });
      });
      pista.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); next.click(); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); prev.click(); }
      });
      var espera;
      pista.addEventListener('scroll', function () {
        clearTimeout(espera);
        espera = setTimeout(pinta, 60);
      }, { passive: true });
      window.addEventListener('resize', pinta);
      pinta();
    });
  }

  function init() {
    // Cada módulo va aislado: esto es mejora progresiva, y que uno se rompa no
    // puede dejar sin nav, sin validación o sin carrito a toda la página. El
    // error se enseña en consola en vez de tragárselo.
    [
      initMobileNav,
      initForms,
      initReveal,
      initAnchorFocus,
      initSchoolSearch,
      initSchoolPrefill,
      initLineItemFields,
      initModalTarjeta,
      initCarrusel,
      initCursoEnCaja,
      initAddons,
      // Después de los dos anteriores: necesita el desplegable de curso ya
      // clonado y el lector de extras que deja initAddons.
      initHermanos,
      initCartBundles,
      initOfertaDigital,
      initSchoolContextPropagation,
    ].forEach(function (fn) {
      try {
        fn();
      } catch (err) {
        if (window.console && console.error) console.error('[fe-ui] ' + fn.name, err);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
